var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-checkbox',{staticClass:"mt-2",attrs:{"name":"check-button"},on:{"change":function($event){return _vm.changeStatus()}},model:{value:(_vm.selectAll),callback:function ($$v) {_vm.selectAll=$$v},expression:"selectAll"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }